// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2AobX","header":"PatientQuestionnaire_header__3OUSP","info":"PatientQuestionnaire_info__VYJLp"};